import React from 'react';
import { Spinner } from 'reactstrap';
import { CenteredContainer } from './';

const Loading = () => (
    <CenteredContainer>
        <Spinner type="grow" color="primary" />
    </CenteredContainer>
)

export default Loading;
